import { SERVICES } from "../lib/constants";

function ServiceCard({ index, title, body }) {
    const isFirst = index === 0;
    const isLast = index === 2;
    return (
        <div
            className={`reveal py-8 md:py-12 md:px-8 ${
                isFirst ? "md:pl-0" : ""
            } ${isLast ? "md:pr-0" : ""} ${
                index > 0
                    ? "md:border-l border-slate-200 border-t md:border-t-0"
                    : ""
            }`}
            data-testid={`service-block-${index + 1}`}
        >
            <p className="font-display text-3xl text-slate-200 font-light mb-6">
                0{index + 1}
            </p>
            <h3 className="font-display text-xl lg:text-2xl text-[#0B132B] font-medium mb-4 tracking-tight">
                {title}
            </h3>
            <p className="text-base text-slate-600 leading-relaxed">{body}</p>
        </div>
    );
}

export function Services() {
    return (
        <section
            id="perimetre"
            className="border-b border-slate-200"
            data-testid="services-section"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16 py-14 md:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-10 md:mb-14">
                    <div className="lg:col-span-4">
                        <p className="reveal text-xs tracking-[0.18em] uppercase text-slate-500 mb-4">
                            01 — Périmètre
                        </p>
                        <h2
                            className="reveal font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0B132B] font-medium leading-[1.05]"
                            data-testid="services-title"
                        >
                            Ce que je fais
                        </h2>
                    </div>
                    <div className="lg:col-span-7 lg:col-start-6">
                        <p
                            className="reveal text-base lg:text-lg text-slate-600 leading-relaxed"
                            data-testid="services-intro"
                        >
                            J'interviens lorsqu'une activité professionnelle
                            ou patrimoniale nécessite de remettre au propre
                            ses données, ses pratiques numériques ou
                            certaines obligations réglementaires courantes.
                            Mon rôle est de repérer les points sensibles, de
                            distinguer les vrais risques des risques
                            théoriques, puis de proposer des corrections
                            simples et applicables.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 border-t border-slate-200">
                    {SERVICES.map((s, i) => (
                        <ServiceCard
                            key={s.title}
                            index={i}
                            title={s.title}
                            body={s.body}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
